<template>
	<ClipListTile
		:clip="clip"
		:title="playerName"
		:is-playing="isPlaying"
		:event-id="eventId"
		:indented="indented"
		:rounded-leading="true"
		@play="handlePlay"
		@edit="handleEdit"
		@share="handleShare"
		@delete="handleDelete"
	>
		<template #leading-placeholder>
			<img
				v-if="athlete"
				class="athlete-icon"
				:src="athlete.imageUrl"
				:alt="athlete.name"
			>
			<Icon
				v-else
				icon-name="users-wm"
			/>
		</template>
		<template #subtitle>
			<span>{{ clip.formattedTimestamp }}</span>
			<span class="divider">|</span>
			<span>{{ runName }}</span>
			<span
				v-if="subtagsCount"
				class="divider"
			>|</span>
			<span v-if="subtagsCount">{{ subtagsCountLabel }}</span>
		</template>
	</ClipListTile>
</template>

<script>
import EventTag from '@videotools/js/api/entities/EventTag';
import { mapGetters } from 'vuex';
import ClipListTile from '@components/clip-list/ClipListTile';
import { ATHLETE_UNKNOWN_ENTITY } from '@videotools/js/constants/athletes';

export default {
	name:       'RunClipListTile',
	components: { ClipListTile },
	props:      {
		clip: {
			type:    EventTag,
			default: null,
		},
		runName: {
			type: String,
		},
		isPlaying: {
			type:    Boolean,
			default: false,
		},
		eventId: {
			default: null,
		},
		indented: {
			type: Boolean,
		},
		subtagsCount: {
			type:    Number,
			default: 0,
		},
	},
	computed: {
		...mapGetters({
			event: 'event/event',
		}),
		playerName() {
			return this.clip.playerName || ATHLETE_UNKNOWN_ENTITY.name;
		},
		clipFormattedDuration() {
			return this.clip.formattedDuration;
		},
		clipFormattedTime() {
			return this.clip.formattedTimestamp;
		},
		athlete() {
			return this.clip.player;
		},
		subtagsCountLabel() {
			return `${this.subtagsCount} ${this.transChoiceUcFirst('commons.tag', this.subtagsCount)}`;
		},
	},
	methods: {
		handleShare(clip) {
			this.$emit('share', clip);
		},
		handleDelete(clip) {
			this.$emit('delete', clip);
		},
		handlePlay(clip) {
			this.$emit('play', clip);
		},
		handleEdit(clip) {
			this.$emit('edit', clip);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';
@import '@videotools/sass/_fonts';

.list-tile::v-deep {
	.list-tile--leading {
		background: none;
	}

	.divider {
		margin-left: 8px;
		margin-right: 8px;
	}
}

img.athlete-icon {
	width: 48px;
	height: 48px;
	border-radius: 50%;
	object-fit: cover;
}

</style>
